const reduced = matchMedia('(prefers-reduced-motion: reduce)');
const current = new URL(location.href);
document.querySelectorAll('.wk-mobile-dock a').forEach(a => {
  const url = new URL(a.href);
  const active = url.pathname === current.pathname && url.searchParams.get('view') === current.searchParams.get('view');
  if (active) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current');
});

// Customer review rail: swipe, scroll or use the keyboard. No automatic animation.
for(const host of document.querySelectorAll('[data-wk-reviews]')){
 const rail=host.querySelector('.wk-review-rail'),toggle=host.querySelector('[data-review-pause]');
 if(toggle)toggle.hidden=true;
 if(rail){rail.tabIndex=0;rail.setAttribute('role','region');rail.setAttribute('aria-label','Customer reviews — scroll to read more');}
}

// Sale banner and first-visit dialog are managed by wk-sellout.js.

// Insert guidance next to the existing delivery app without replacing or modifying its fields.
function markDeliveryDate(context = document) {
  const fields = context.querySelectorAll?.('input[type="date"],input[id*="datepicker"],input[name*="delivery_date"],input[name*="shipping_date"],input[id*="delivery-date"],input[id*="shipping-date"]') || [];
  for (const input of fields) {
    if (!input.closest('.cart-page,.cart-drawer') || input.dataset.wkDateMarked) continue;
    const guide = document.querySelector('[data-wk-date-prompt]'); if (!guide) continue;
    input.dataset.wkDateMarked = 'true'; const host = input.closest('form')?.id === 'cart-form' ? input.parentElement : input.closest('.shopify-app-block') || input.parentElement;
    host.before(guide); guide.hidden = false;
  }
}
markDeliveryDate();
let dateQueued = false;
new MutationObserver(() => { if (dateQueued) return; dateQueued = true; requestAnimationFrame(() => { markDeliveryDate(); dateQueued = false; }); }).observe(document.body, { childList: true, subtree: true });
